import React, { useEffect, useRef, useState, useContext } from "react";
import AppImages from "../../../../../../constants/images";
import { InternalAPIError } from "../../../../../../utils/apiErrors";
import { BOTAPIError } from "../../../../../../utils/apiErrors";
import { handleApiError } from "../../../../../../utils/globalErrorHandler";

import {
  handlePIIChange,
  getHighlightedText,
} from "../../../../../../services/piiService";
import { getUseSkills } from "../../../services/promptManagementService";
import { CropImage } from "../cropImage";
import { defaultDisclaimerText } from "../../../../../../constants/enums";
import {
  getPromptManagementStoreData,
  getCreativityData,
} from "../../../services/promptManagementService";
import SelectByPreferences from "../selectByPreferences";
import { useNavigate } from "react-router-dom";
import { splitPromptsAndTags } from "../../../shared/promptConverter";
import showMessage from "../../../../../common/message";
import PromptResults from "../promptResults";
import { hasGroupAccess } from "../../../../../../services/commonService";
import { UserContext } from "../../../../../../context/user/userContext";
import loaderContext from "../../../../../../context/loader/loaderContext";
import { promptAPIURI } from "../../../../../../constants/enums.js";
import { extractAndRemoveFollowUps } from "../../../../../../services/commonService";

const UpdatePromptStepOneandTwo = ({
  promptData,
  handlePromptStepOneandTwoData,
  prevSelectedPrompts,
  generatedPrompt,
  handleAddPrompt,
  handleSaveImage,
  handleCancelClick,
  validationField,
  isReadonlyAccess,
  setSelectedPrompts,
  handleAppendTags,
  chatbotResponse,
  setChatbotResponse,
  mksDefaultConfiguration,
}) => {
  const [promptTitles, setPromptTitles] = useState([]);
  const [showTab, setShowTab] = useState(1);
  const navigate = useNavigate();
  const [promptTitlesOriginal, setPromptTitlesOriginal] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [useSkills, setUseSkills] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [showCropImagePopup, setShowCropImagePopup] = useState(false);
  const [creativityData, setCreativityData] = useState([]);
  const [selectedChatbot, setSelectedChatbot] = useState();
  const [selectedPromptForTest, setSelectedPromptForTest] = useState("");
  const [loadHighlightedText, setLoadHighlightedText] = useState(false);
  const [tempTitle, setTempTitle] = useState("");
  const { updateLoaderStatus } = useContext(loaderContext);
  const [promptStepOneDataOriginal, setPromptStepOneDataOriginal] = useState({
    isGuideLineChecked: false,
    selectedSkill: "-1",
    promptTitle: "",
    description: "",
    promptText1: "",
    promptText2: "",
    promptText3: "",
    fileName: "",
    imageBase64String: "",
    imageURL: "",
    mimeType: "",
    inputWordCount: null,
    selectPreferences: "-1",
  });
  const [ASSISTANT, TOOL, ERROR] = ["assistant", "tool", "error"];

  const suggestRef = useRef(null);
  const skillref = useRef(null);
  const titleRef = useRef("");
  const descriptionRef = useRef("");
  const text1Ref = useRef("");
  const text2Ref = useRef("");
  const text3Ref = useRef("");
  const guideLineCheckedRef = useRef(false);
  const wordCountRef = useRef(null);
  const divPreferencesRef = useRef(null);
  const [promptMessage, setPromptMessage] = useState([]);
  const { state } = useContext(UserContext);
  const securityGroups = state?.user?.userProfile?.msalSecurityGroup;
  const getDataPromptStoreData = async () => {
    try {
      const data = await getPromptManagementStoreData();
      const listOfTitlesAndIds = data.map((prompt) => ({
        id: prompt.Id,
        title: prompt.Title,
      }));
      setPromptTitlesOriginal(listOfTitlesAndIds);
    } catch (error) {
      handleApiError(new InternalAPIError());
    }
  };

  const getDataOfCreativity = async () => {
    try {
      const creativityData = await getCreativityData();
      setCreativityData(creativityData);
    } catch (error) {
      handleApiError(new InternalAPIError());
    }
  };

  useEffect(() => {
    getDataPromptStoreData();
    getDataOfCreativity();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      // Check if the click is outside both the menu and toggle button
      if (
        showSuggestions &&
        suggestRef.current &&
        !suggestRef.current.contains(e.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSuggestions]);
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (showSuggestions && promptTitles.length > 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          setSelectedIndex(
            (prevIndex) => (prevIndex + 1) % promptTitles.length
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          setSelectedIndex(
            (prevIndex) =>
              (prevIndex - 1 + promptTitles.length) % promptTitles.length
          );
        } else if (e.key === "Enter" && selectedIndex >= 0) {
          e.preventDefault();
          const selectedTitle = promptTitles[selectedIndex];
          handleSuggestionClick(selectedTitle);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex, promptTitles, showSuggestions]);

  useEffect(() => {
    if (promptData !== null) {
      setPromptStepOneDataOriginal(promptData);
      setTempTitle(promptData?.promptTitle);
      bindPreviousPromptData();
      getUseSkillsData();
      if (
        prevSelectedPrompts !== null &&
        prevSelectedPrompts !== undefined &&
        prevSelectedPrompts?.length > 0
      )
        setSelectedPromptForTest(prevSelectedPrompts[0].PromptText);
      setLoadHighlightedText(true);
    }
  }, [promptData]);

  useEffect(() => {
    highlightText();
  }, [loadHighlightedText]);

  useEffect(() => {
    if (
      validationField !== null &&
      validationField !== undefined &&
      validationField !== ""
    ) {
      setPromptValidation();
    }
  }, [validationField]);

  const highlightText = () => {
    if (promptStepOneDataOriginal?.description != null) {
      descriptionRef.current.innerHTML = getHighlightedText(
        promptStepOneDataOriginal?.description
      );
    }
    if (promptStepOneDataOriginal?.promptText1 != null) {
      text1Ref.current.innerHTML = getHighlightedText(
        promptStepOneDataOriginal?.promptText1
      );
    }
    if (promptStepOneDataOriginal?.promptText2 != null) {
      text2Ref.current.innerHTML = getHighlightedText(
        promptStepOneDataOriginal?.promptText2
      );
    }
    if (promptStepOneDataOriginal?.promptText3 != null) {
      text3Ref.current.innerHTML = getHighlightedText(
        promptStepOneDataOriginal?.promptText3
      );
    }
  };

  const getUseSkillsData = () => {
    getUseSkills().then((resp) => {
      setUseSkills(resp);
      const selectedSkill = resp?.filter(
        (item) => item.Id === parseInt(promptData?.selectedSkill)
      )[0];
      setSelectedChatbot(selectedSkill);
    });
  };

  const bindPreviousPromptData = () => {
    if (prevSelectedPrompts !== null && prevSelectedPrompts.length > 0) {
      setPromptMessage(prevSelectedPrompts);
    } else {
      setPromptMessage(generatedPrompt);
    }
  };

  const setPromptValidation = () => {
    if (validationField === "isGuideLineChecked") {
      guideLineCheckedRef.current.classList.add("border-red");
      guideLineCheckedRef.current.focus();
    }
    if (validationField === "selectedSkill") {
      skillref.current.classList.add("border-red");
      skillref.current.focus();
    }
    if (validationField === "promptTitle") {
      titleRef.current.classList.add("border-red");
      titleRef.current.focus();
    }
    if (validationField === "description") {
      descriptionRef.current.classList.add("border-red");
      descriptionRef.current.focus();
    }
    if (validationField === "promptText1") {
      text1Ref.current.classList.add("border-red");
      text1Ref.current.focus();
    }
    if (validationField === "promptText2") {
      text2Ref.current.classList.add("border-red");
      text2Ref.current.focus();
    }
    if (validationField === "promptText3") {
      text3Ref.current.classList.add("border-red");
      text3Ref.current.focus();
    }
    if (validationField === "selectPreferences") {
      divPreferencesRef.current.classList.add("border-red");
      divPreferencesRef.current.focus();
    }
    if (validationField === "inputWordCount") {
      wordCountRef.current.classList.add("border-red");
      wordCountRef.current.focus();
    }
  };

  const handleSuggestionClick = (selectedTitle) => {
    handlePromptStepOneandTwoData(selectedTitle, "promptTitle");
    setShowSuggestions(false);
  };

  const handleImageSave = (croppedImageUrl, dataUrl, fileName, mimeType) => {
    handleSaveImage(croppedImageUrl, dataUrl, fileName, mimeType);
    setShowCropImagePopup(false);
  };

  const handleImageCancelClick = () => {
    handleCancelClick(AppImages.ImageCloudUpload);
    setShowCropImagePopup(false);
  };

  const handleShowPopup = () => {
    if (!isReadonlyAccess) setShowCropImagePopup(true);
  };

  const handleSetGuideline = (event) => {
    handlePromptStepOneandTwoData(
      guideLineCheckedRef.current.checked,
      "isGuideLineChecked"
    );
  };

  const validateRegeneratePrompt = () => {
    if (
      promptStepOneDataOriginal?.promptText1?.trim() === "" ||
      promptStepOneDataOriginal?.promptText1 === null ||
      promptStepOneDataOriginal?.promptText1 === undefined
    ) {
      text1Ref.current.classList.add("border-red");
      text1Ref.current.focus();
      showMessage("Please provide background for Prompt.", -2);
      return false;
    }

    if (
      promptStepOneDataOriginal?.promptText2?.trim() === "" ||
      promptStepOneDataOriginal?.promptText2 === null ||
      promptStepOneDataOriginal?.promptText2 === undefined
    ) {
      showMessage("Please provide desired output format for Prompt.", -2);
      text2Ref.current.classList.add("border-red");
      text2Ref.current.focus();
      return false;
    }

    // if (
    //   promptStepOneDataOriginal?.promptText3?.trim() === "" ||
    //   promptStepOneDataOriginal?.promptText3 === null ||
    //   promptStepOneDataOriginal?.promptText3 === undefined
    // ) {
    //   showMessage("Please provide source/input for Prompt.", -2);
    //   text3Ref.current.classList.add("border-red");
    //   text3Ref.current.focus();
    //   return false;
    // }

    if (
      promptStepOneDataOriginal.selectPreferences === null ||
      promptStepOneDataOriginal.selectPreferences === undefined ||
      promptStepOneDataOriginal.selectPreferences === "-1" ||
      promptStepOneDataOriginal.selectPreferences === 0
    ) {
      showMessage("Please select Preference.", -2);
      divPreferencesRef.current.classList.add("border-red");
      return false;
    }

    if (
      promptStepOneDataOriginal.inputWordCount === null ||
      promptStepOneDataOriginal.inputWordCount === undefined ||
      promptStepOneDataOriginal.inputWordCount === ""
    ) {
      showMessage("Please fill Word Count.", -2);
      wordCountRef.current.classList.add("border-red");
      return false;
    }
  };

  const handleRegeneratePromptResultWrapper = async () => {
    try {
      if (validateRegeneratePrompt() === false) {
        return;
      }
      updateLoaderStatus(true);
      let finalPrompt = promptStepOneDataOriginal?.promptText1;

      let selectedPreferenceName = "";
      if (promptStepOneDataOriginal.selectedPreferenceName === "") {
        selectedPreferenceName = creativityData.filter(
          (s) => s.Id === promptStepOneDataOriginal?.selectPreferences
        )[0].Name;
      } else {
        selectedPreferenceName =
          promptStepOneDataOriginal?.selectedPreferenceName;
      }

      let response = "";

      let userMessageModel = {
        user_messages: finalPrompt,
        word_count: promptStepOneDataOriginal?.inputWordCount,
        mode: selectedPreferenceName,
      };

      try {
        const apiURL = process.env.REACT_APP_PROMPT_WRAPPER_URL + promptAPIURI;
        const apiResponse = await fetch(apiURL, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userMessageModel),
        });

        const data = await apiResponse.text();
        let replacedChunk = JSON.parse(data);
        if (replacedChunk.choices.length > 0) {
          replacedChunk.choices[0].messages.forEach((msg) => {
            if (msg?.role === "tool") {
            } else if (msg?.role === "assistant") {
              response = response + msg?.content;
            }
          });
        }
      } catch (fetchError) {
        updateLoaderStatus(false);
        handleApiError(new BOTAPIError());
      }

      try {
        const data = splitPromptsAndTags(response);
        let promptsArray = data.map((item) => {
          return {
            ModelAPIURL: "",
            PromptStyle: "",
            WordCount: 0,
            PromptGenerated: false,
            PromptText: item.prompt,
            Status: "",
            Id: 0,
            tags: item.tags,
          };
        });
        setPromptMessage([...promptsArray]);
        updateLoaderStatus(false);
        setSelectedPrompts([...promptsArray]);
      } catch (error) {
        let newPrompts = [];
        newPrompts.push({
          ModelAPIURL: "",
          PromptStyle: "",
          WordCount: 0,
          PromptGenerated: false,
          PromptText: JSON.stringify(response),
          Status: "",
          Id: 0,
          tags: [],
        });
        setPromptMessage((existingPrompt) => {
          return [...newPrompts];
        });
        setSelectedPrompts((existingPrompt) => {
          return newPrompts;
        });
        updateLoaderStatus(false);
      }
    } catch (ex) {
      updateLoaderStatus(false);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegeneratePromptResult = async () => {
    try {
      if (validateRegeneratePrompt() === false) {
        return;
      }
      updateLoaderStatus(true);
      let compbinedPromptText = process.env.REACT_APP_WRITE_FOUR_PROMPT_TEXT;
      let compbinedPrompt =
        promptStepOneDataOriginal?.promptText1 +
        " " +
        promptStepOneDataOriginal?.promptText2 +
        " " +
        promptStepOneDataOriginal?.promptText3;
      let selectedPreferenceName = "";
      if (promptStepOneDataOriginal.selectedPreferenceName === "") {
        selectedPreferenceName = creativityData.filter(
          (s) => s.Id === promptStepOneDataOriginal?.selectPreferences
        )[0].Name;
      } else {
        selectedPreferenceName =
          promptStepOneDataOriginal?.selectedPreferenceName;
      }

      let finalPrompt = compbinedPromptText
        .replace("{prompttext}", compbinedPrompt)
        .replace("{textLength}", promptStepOneDataOriginal?.inputWordCount)
        .replace("{preference}", selectedPreferenceName);
      let response = "";

      let stringBody = mksDefaultConfiguration?.body;
      let userMessage = mksDefaultConfiguration?.userMessage;

      let message1 = userMessage?.replace("$Message", `"$"`);

      let parseMessage1 = JSON.parse(message1);
      parseMessage1.content[0].text = finalPrompt;

      let requestBody = stringBody.replace(",$UserMessage", "");
      let convertedJson = JSON.parse(requestBody);
      convertedJson.messages.push(parseMessage1);

      convertedJson.messages.map((item) => {
        if (item.role === "user") {
          item.content[0].text = finalPrompt;
        } else if (item.role === "system") {
          item.content[0].text =
            "Given a task description or existing prompt, produce a detailed system prompt to guide a language model in completing the task effectively.# Guidelines - Understand the Task: Grasp the main objective, goals, requirements, constraints, and expected output.- Minimal Changes: If an existing prompt is provided, improve it only if it s simple. For complex prompts, enhance clarity and add missing elements without altering the original structure.- Reasoning Before Conclusions**: Encourage reasoning steps before any conclusions are reached. ATTENTION! If the user provides examples where the reasoning happens afterward, REVERSE the order! NEVER START EXAMPLES WITH CONCLUSIONS!- Reasoning Order: Call out reasoning portions of the prompt and conclusion parts (specific fields by name). For each, determine the ORDER in which this is done, and whether it needs to be reversed.- Conclusion, classifications, or results should ALWAYS appear last.- Examples: Include high-quality examples if helpful, using placeholders [in brackets] for complex elements.- What kinds of examples may need to be included, how many, and whether they are complex enough to benefit from placeholders.- Clarity and Conciseness: Use clear, specific language. Avoid unnecessary instructions or bland statements.- Formatting: Use markdown features for readability. DO NOT USE CODE BLOCKS UNLESS SPECIFICALLY REQUESTED.- Preserve User Content: If the input task or prompt includes extensive guidelines or examples, preserve them entirely, or as closely as possible. If they are vague, consider breaking down into sub-steps. Keep any details, guidelines, examples, variables, or placeholders provided by the user.- Constants: DO include constants in the prompt, as they are not susceptible to prompt injection. Such as guides, rubrics, and examples.- Output Format: Explicitly the most appropriate output format, in detail. This should include length and syntax (e.g. short sentence, paragraph, JSON, etc.)- For tasks outputting well-defined or structured data (classification, JSON, etc.) bias toward outputting a JSON.- JSON should never be wrapped in code blocks () unless explicitly requested.The final prompt you output should adhere to the following structure below. Do not include any additional commentary, only output the completed system prompt. SPECIFICALLY, do not include any additional messages at the start or end of the prompt. (e.g. no [Concise instruction describing the task - this should be the first line in the prompt, no section header][Additional details as needed.][Optional sections with headings or bullet points for detailed steps.]# Steps [optional][optional: a detailed breakdown of the steps necessary to accomplish the task]# Output Format[Specifically call out how the output should be formatted, be it response length, structure e.g. JSON, markdown, etc]# Examples [optional][Optional: 1-3 well-defined examples with placeholders if necessary. Clearly mark where examples start and end, and what the input and output are. User placeholders as necessary.][If the examples are shorter than what a realistic example is expected to be, make a reference with () explaining how real examples should be longer / shorter / different. AND USE PLACEHOLDERS! ]# Notes [optional][optional: edge cases, details, and an area to call or repeat out specific important considerations]";
        }
        return item;
      });

      try {
        const responseA = await fetch(
          removeTrailingSlash(mksDefaultConfiguration.url),
          {
            method: mksDefaultConfiguration.method,
            headers: mksDefaultConfiguration.headers,
            body: JSON.stringify(convertedJson),
          }
        );

        if (!responseA.ok || !responseA.body) {
          handleApiError(new BOTAPIError());
          return;
        }
        const reader = responseA.body.getReader();
        const decoder = new TextDecoder();
        const loopRunner = true;

        while (loopRunner) {
          try {
            const { value, done } = await reader.read();
            if (done) {
              break;
            }
            const decodedChunk = decoder.decode(value, { stream: true });
            let datas;

            try {
              // Process the decoded chunk
              datas = JSON.parse(
                JSON.stringify(
                  decodedChunk
                    .replace("data: ", "")
                    .split("\n\ndata:")
                    .slice(0, -1)
                )
              );
            } catch (decodeError) {
              console.log("Error processing decoded chunk:", decodeError);
              continue; // Skip this chunk if JSON parsing fails
            }

            // Process each item in the parsed data
            let counter = 0;
            datas.forEach((da) => {
              let jsonArray = null;
              try {
                jsonArray = JSON.parse(da);
                if (jsonArray.choices.length > 0) {
                  const text = jsonArray.choices[0].delta?.content || "";
                  if (counter < 2 && (text.match(/\n/) || []).length) {
                    return;
                  }
                  response = response + text;
                  counter++;
                }
              } catch (parseError) {
                console.log(
                  "Error parsing JSON array item:",
                  parseError,
                  " Raw Item ",
                  da
                );
              }
            });
          } catch (readError) {
            //handleApiError(new BOTAPIError());
            break; // Exit the loop if reading fails
          }
        }
      } catch (fetchError) {
        handleApiError(new BOTAPIError());
        // Handle fetch error, such as displaying a message to the user
      }

      try {
        const data = splitPromptsAndTags(response);
        let promptsArray = data.map((item) => {
          return {
            ModelAPIURL: "",
            PromptStyle: "",
            WordCount: 0,
            PromptGenerated: false,
            PromptText: item.prompt,
            Status: "",
            Id: 0,
            tags: item.tags,
          };
        });
        setPromptMessage([...promptsArray]);
        updateLoaderStatus(false);
        setSelectedPrompts([...promptsArray]);
      } catch (error) {
        let newPrompts = [];
        newPrompts.push({
          ModelAPIURL: "",
          PromptStyle: "",
          WordCount: 0,
          PromptGenerated: false,
          PromptText: JSON.stringify(response),
          Status: "",
          Id: 0,
          tags: [],
        });
        setPromptMessage((existingPrompt) => {
          return [...newPrompts];
        });
        setSelectedPrompts((existingPrompt) => {
          return newPrompts;
        });
        updateLoaderStatus(false);
      }
    } catch (ex) {
      updateLoaderStatus(false);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegenerateClick = () => {
    const isNewFlag = process.env.REACT_APP_PROMPT_FLAG_MKS_NEW;
    if (isNewFlag === "true") {
      handleRegeneratePromptResultWrapper();
    } else {
      handleRegeneratePromptResult();
    }
  };

  const onPreferencesSelection = async (
    preferencesId,
    selectedPreferenceName
  ) => {
    divPreferencesRef.current.classList.remove("border-red");
    handlePromptStepOneandTwoData(preferencesId, "selectPreferences");
    handlePromptStepOneandTwoData(
      selectedPreferenceName,
      "selectedPreferenceName"
    );
  };

  const handleWordCountChange = (e) => {
    wordCountRef.current.classList.remove("border-red");
    const newValue = e.target.value;
    const cursorPosition = e.target.selectionStart;
    if (/^\d*$/.test(newValue) && parseInt(newValue) <= 150) {
      if (parseInt(newValue) === 0) {
        handlePromptStepOneandTwoData("", "inputWordCount");
      } else handlePromptStepOneandTwoData(newValue, "inputWordCount");
    } else if (newValue === "") {
      handlePromptStepOneandTwoData("", "inputWordCount");
    } else if (parseInt(newValue) > 150) {
      showMessage("Word count should be less than or equal to 150.", -2);
    } else {
      if (/^\d*$/.test(newValue)) {
        if (parseInt(newValue) <= 150) {
          handlePromptStepOneandTwoData(newValue, "inputWordCount");
        }
      } else {
        const numericValue = newValue.replace(/\D/g, "");
        handlePromptStepOneandTwoData(numericValue, "inputWordCount");
      }
    }
    setTimeout(() => {
      if (wordCountRef.current) {
        wordCountRef.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 10);
  };

  const checkIfPromptExists = (value) => {
    let item = prevSelectedPrompts.find(
      (item) => item.PromptText === value.PromptText
    );
    if (item !== null && item !== undefined) {
      item.PromptGenerated = true;
      return item;
    } else {
      return null;
    }
  };

  const handlePromptSelected = (event, item) => {
    setSelectedPromptForTest(item.PromptText);
    if (event.currentTarget.checked) {
      const existingItem = checkIfPromptExists(item);
      if (existingItem !== null) {
        handleAddPrompt(item);
      } else {
        const data = {
          ModelAPIURL: "",
          PromptStyle: "",
          WordCount: 0,
          PromptGenerated: true,
          PromptText: item.PromptText,
          Id: 0,
          Status: "",
        };
        handleAddPrompt(data);
      }
    }

    if (item.tags !== undefined && item.tags.length > 0)
      handleAppendTags(item.tags);
  };
  const handleCardClick = (id) => {
    if (id !== undefined && id !== null && id !== 0) {
      navigate(`/updatePrompt/${id}`);
    }
  };

  const handleSelectedSkillChange = (skillId) => {
    const selectedSkill = useSkills.filter(
      (item) => item.Id === parseInt(skillId)
    )[0];

    const access = hasGroupAccess(
      securityGroups,
      selectedSkill?.SecurityGroupId
    );
    if (!access) {
      showMessage(
        "You don't have access to " + selectedSkill.Name + " bot.",
        -2
      );
      return;
    }

    handlePromptStepOneandTwoData(skillId, "selectedSkill");
    setSelectedChatbot(selectedSkill);
  };

  const removeTrailingSlash = (url) => {
    return url.endsWith("\\") ? url.slice(0, -1) : url;
  };
  const handleLoadGenericApiConfigurations = async () => {
    let inputText = selectedPromptForTest;
    let userMessage = selectedChatbot.ChatbotConfiguration.UserMessageFormat;
    userMessage = userMessage.replace("$Message", `"${inputText}"`);
    let userMessageModel2 = selectedChatbot.messageBody.replace(
      "$UserMessage",
      userMessage
    );

    let response = "";
    const responseA = await fetch(removeTrailingSlash(selectedChatbot.aiUrl), {
      method: "POST",
      headers: selectedChatbot.headers,
      body: userMessageModel2,
    });
    if (!responseA.ok || !responseA.body) {
      handleApiError(new BOTAPIError());
      return;
    }

    const reader = responseA.body.getReader();
    const decoder = new TextDecoder("utf-8");
    const loopRunner = true;
    let citations = [];

    while (loopRunner) {
      try {
        const { value, done } = await reader.read();
        if (done) {
          break;
        }

        let decodedChunk = decoder.decode(value, { stream: true });
        let replacedChunk = decodedChunk.replace("data: ", "");

        let findContext =
          replacedChunk.indexOf("context") &&
          replacedChunk.indexOf("citations");
        if (findContext > -1) {
          citations =
            JSON.parse(replacedChunk)?.choices[0]?.delta?.context?.citations;
        }
        let splitChunk = replacedChunk.split("\n\ndata:").slice(0, -1);

        let datas = JSON.parse(JSON.stringify(splitChunk));
        let counter = 0;

        datas.forEach((da) => {
          let jsonArray = null;
          try {
            jsonArray = JSON.parse(da);
            if (jsonArray.choices.length > 0) {
              const text = jsonArray.choices[0].delta?.content || "";
              if (counter < 2 && (text.match(/\n/) || []).length) {
                return;
              }
              response = response + text;
              counter++;
            }
          } catch (parseError) {
            console.log(
              "Error parsing JSON array item:",
              parseError,
              " Raw Item ",
              da
            );
          }
        });
      } catch (readError) {
        break; // Exit the loop if reading fails
      }
      updateLoaderStatus(false);
    }
    let cbResponse = {
      description: response,
      citations: citations,
    };
    setChatbotResponse(cbResponse);
  };

  const handleLoadGenericApiConfigurationsV2 = async () => {
    let inputText = selectedPromptForTest;
    inputText += " " + promptData?.promptText2;

    let response = "";
    let citations = [];

    let userMessageModel2 = {
      skill_store_id: promptData?.selectedSkill,
      user_messages: inputText,
      ModelId: "default",
      ModelName: "gpt-4o"
    };
    const cleanEnv = (value) =>
      typeof value === "string" ? value.trim().replace(/^["']|["']$/g, "") : value;

    userMessageModel2 = JSON.stringify(userMessageModel2);
    try {
      const apiResponse = await fetch(
        cleanEnv(process.env.REACT_APP_CHAT_SKILL_WRAPPER_URL),
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: userMessageModel2,
        }
      );
      if (!apiResponse.ok || !apiResponse.body) {
        updateLoaderStatus(false);
        return;
      }
      const reader = apiResponse.body.getReader();
      const decoder = new TextDecoder("utf-8");
      const loopRunner = true;
      let citations = [];
      let runningText = "";
      let result = {};
      while (loopRunner) {
        try {
          //setIsSkillProcessing(true);
          const { value, done } = await reader.read();
          if (done) {
            break;
          }
          let decodedChunk = decoder.decode(value, { stream: true });
          const objects = decodedChunk.split("\n");
          objects.forEach((obj) => {
            try {
              if (obj !== "" && obj !== "{}") {
                runningText += obj;
                result = JSON.parse(runningText);
                if (result.choices?.length > 0) {
                  result.choices[0].messages.forEach((msg) => {
                    msg.id = result.id;
                    msg.date = new Date().toISOString();
                  });
                  if (
                    result.choices[0].messages?.some(
                      (m) => m.role === ASSISTANT
                    )
                  ) {
                  }
                  result.choices[0].messages.forEach((resultObj) => {
                    if (resultObj.role === ASSISTANT) {
                      response = response + resultObj.content;
                    }
                    if (resultObj.role === TOOL) {
                      if (
                        resultObj?.role &&
                        resultObj?.role === "tool" &&
                        resultObj?.content !== ""
                      ) {
                        try {
                          let contents = JSON.parse(resultObj.content);
                          if (contents?.citations) {
                            citations = contents.citations;
                          }
                        } catch {
                          return [];
                        }
                      }
                    }
                  });
                } else if (result.error) {
                  handleApiError(new BOTAPIError());
                  updateLoaderStatus(false);
                }
                runningText = "";
              }
            } catch (e) {
              if (!(e instanceof SyntaxError)) {
                handleApiError(new BOTAPIError());
                updateLoaderStatus(false);
              }
            }
          });
        } catch (readError) { }
        updateLoaderStatus(false);
      }
    } catch (ex) {
      console.log(ex);
      updateLoaderStatus(false);
    }
    const result = extractAndRemoveFollowUps(response);
    response = result.modifiedText?.replace(/\[doc\d+\]/g, "");
    let cbResponse = {
      description: response,
      citations: citations,
    };
    setChatbotResponse(cbResponse);
  };

  const handleTestGeneratedPrompt = async () => {
    updateLoaderStatus(true);
    if (selectedChatbot === undefined) {
      showMessage("Please select a skill first.", -2);
      updateLoaderStatus(false);
      return;
    }
    if (selectedPromptForTest === "") {
      showMessage("Please select a prompt first.", -2);
      updateLoaderStatus(false);
      return;
    }
    try {
      const isNewFlag = process.env.REACT_APP_PROMPT_FLAG_MKS_NEW;
      if (isNewFlag === "true") {
        await handleLoadGenericApiConfigurationsV2();
      } else {
        await handleLoadGenericApiConfigurations();
      }
    } catch (error) {
      updateLoaderStatus(false);
      handleApiError(new BOTAPIError());
    } finally {
      updateLoaderStatus(false);
    }
  };

  const getInitials = (str) => {
    // Split the string into words
    if (str !== "") {
      const words = str.trim().split(" ");

      // Extract the first two words and get their initials
      const initials = words
        .slice(0, 2)
        .map((word) => word[0]?.toUpperCase())
        .join("");

      return initials;
    }
    return "";
  };

  return (
    <>
      <div className="dash-section p20 prompt-step-one">
        <div
          className={
            isReadonlyAccess ? "check-ackn disabled-parent" : "check-ackn"
          }
        >
          <label className="check-contain">
            <input
              disabled={isReadonlyAccess}
              type="checkbox"
              checked={promptStepOneDataOriginal?.isGuideLineChecked}
              className={
                isReadonlyAccess ? "p-checkbox disabled-element" : "p-checkbox"
              }
              onChange={() => {
                handleSetGuideline();
              }}
              ref={guideLineCheckedRef}
            />
            <span
              className={
                isReadonlyAccess
                  ? " checkmark-check disabled-element"
                  : "checkmark-check"
              }
            ></span>
          </label>
          <p>
            {defaultDisclaimerText}
            {!promptStepOneDataOriginal?.isImported && (
              <span className="red">*</span>
            )}
          </p>
        </div>

        <div className="prompt-img-title">
          <div className="prompt-mobile-wrap">
            <div className="prompt-title-wrap">
              <h3 className="prompt-title">
                Prompt Title <span className="red">*</span>{" "}
              </h3>
              <input
                maxLength={256}
                disabled={isReadonlyAccess}
                type="textbox"
                className="prompt-text"
                value={tempTitle}
                onBlur={(e) =>
                  handlePromptStepOneandTwoData(e.target.value, "promptTitle")
                }
                onInput={(e) => {
                  setTempTitle(e.target.value);
                  setPromptTitles([
                    ...new Set(
                      promptTitlesOriginal.filter((prompt) =>
                        prompt.title
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                      )
                    ),
                  ]);
                  titleRef.current.classList.remove("border-red");
                  setShowSuggestions(e.target.value.length > 0);
                  e.preventDefault();
                }}
                ref={titleRef}
              />
              <div ref={suggestRef}>
                {showSuggestions && promptTitles.length > 0 && (
                  <div className="suggestions mks-suggestion-prompt">
                    <div className="suggestion-item-heading">Suggestions</div>
                    {promptTitles.map((prompt, index) => (
                      <div
                        className={`flex-row suggestion-item ${index === selectedIndex ? "selected" : ""
                          }`}
                        key={index}
                      >
                        <div
                          onClick={() => handleSuggestionClick(prompt.title)}
                        >
                          {prompt.title}
                        </div>
                        <div
                          className="view-btn"
                          onClick={() => handleCardClick(prompt.id)}
                        >
                          View
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {promptStepOneDataOriginal?.imageBase64String !== undefined &&
              promptStepOneDataOriginal?.imageBase64String !== null &&
              promptStepOneDataOriginal?.imageBase64String !== "" ? (
              <div
                className={
                  isReadonlyAccess ? "prompt-img disabled-parent" : "prompt-img"
                }
              >
                <img
                  disabled={isReadonlyAccess}
                  src={promptStepOneDataOriginal?.imageBase64String}
                  title="Upload an Image"
                  alt=""
                  onClick={() => handleShowPopup()}
                  className={
                    isReadonlyAccess
                      ? "upload-icon disabled-element"
                      : "upload-icon"
                  }
                />
              </div>
            ) : (
              <div
                onClick={() => handleShowPopup()}
                className="user-profile-menu w-inline-block"
              >
                <div
                  className={
                    isReadonlyAccess
                      ? "user-update-prompt disabled-element"
                      : "user-update-prompt"
                  }
                >
                  <span>
                    {getInitials(promptStepOneDataOriginal?.promptTitle)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          className={
            isReadonlyAccess
              ? "prompt-desc-wrap disabled-element"
              : "prompt-desc-wrap"
          }
        >
          <h3 className="prompt-title">
            Short Description <span className="red">*</span>
          </h3>
          <div
            contentEditable={!isReadonlyAccess}
            suppressContentEditableWarning
            className={
              isReadonlyAccess
                ? "prompt-textarea prompt-pii disabled-parent"
                : "prompt-textarea prompt-pii"
            }
            value={promptStepOneDataOriginal?.description}
            onInput={(e) => {
              const textValue = e.currentTarget.innerText;
              handlePromptStepOneandTwoData(textValue, "description");
              descriptionRef.current.classList.remove("border-red");
              if (textValue.length > 1000) {
                // Truncate to 1000 characters
                e.currentTarget.innerText = textValue.slice(0, 1000);

                // Move cursor to the end
                const range = document.createRange();
                const sel = window.getSelection();
                range.selectNodeContents(e.currentTarget);
                range.collapse(false);
                sel.removeAllRanges();
                sel.addRange(range);
              }
              e.preventDefault();
            }}
            onBlur={(e) => handlePIIChange(e)}
            rows="4"
            ref={descriptionRef}
          ></div>
        </div>
        <div className="dash-section p20 prompt-step-two">
          <div className="prompt-explanaion">
            <div
              className={
                isReadonlyAccess ? "prompt-box disabled-parent" : "prompt-box"
              }
            >
              <p className="prompt-title-small">
                Provide some background and explain the use case for which you
                would like to design the prompt
                {!promptStepOneDataOriginal?.isImported && (
                  <span className="red">*</span>
                )}
              </p>
              <div
                contentEditable={!isReadonlyAccess}
                suppressContentEditableWarning
                ref={text1Ref}
                value={promptStepOneDataOriginal?.promptText1}
                className={
                  isReadonlyAccess
                    ? "prompt-textarea prompt-pii disabled-element"
                    : "prompt-textarea prompt-pii"
                }
                onInput={(e) => {
                  const textValue = e.currentTarget.innerText;
                  handlePromptStepOneandTwoData(textValue, "promptText1");
                  text1Ref.current.classList.remove("border-red");
                  if (textValue.length > 1000) {
                    // Truncate to 1000 characters
                    e.currentTarget.innerText = textValue.slice(0, 1000);

                    // Move cursor to the end
                    const range = document.createRange();
                    const sel = window.getSelection();
                    range.selectNodeContents(e.currentTarget);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                  }
                  e.preventDefault();
                }}
                onBlur={(e) => handlePIIChange(e)}
                rows="5"
              ></div>
            </div>
            <div
              className={
                isReadonlyAccess ? "prompt-box disabled-parent" : "prompt-box"
              }
            >
              <p className="prompt-title-small">
                Articulate the desired output format in which you would like to
                see the response?
                {!promptStepOneDataOriginal?.isImported && (
                  <span className="red">*</span>
                )}
              </p>
              <div
                contentEditable={!isReadonlyAccess}
                suppressContentEditableWarning
                ref={text2Ref}
                value={promptStepOneDataOriginal?.promptText2}
                onInput={(e) => {
                  const textValue = e.currentTarget.innerText;
                  handlePromptStepOneandTwoData(textValue, "promptText2");
                  text2Ref.current.classList.remove("border-red");
                  if (textValue.length > 1000) {
                    // Truncate to 1000 characters
                    e.currentTarget.innerText = textValue.slice(0, 1000);

                    // Move cursor to the end
                    const range = document.createRange();
                    const sel = window.getSelection();
                    range.selectNodeContents(e.currentTarget);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                  }
                  e.preventDefault();
                }}
                onBlur={(e) => handlePIIChange(e)}
                className={
                  isReadonlyAccess
                    ? "prompt-textarea prompt-pii disabled-element"
                    : "prompt-textarea prompt-pii"
                }
                rows="5"
              ></div>
            </div>
            <div
              className={
                isReadonlyAccess ? "prompt-box disabled-parent" : "prompt-box"
              }
            >
              <p className="prompt-title-small">
                Tell us something more about the source/input data?
                {/* {!promptStepOneDataOriginal?.isImported && (
                  <span className="red">*</span>
                )} */}
              </p>
              <div
                contentEditable={!isReadonlyAccess}
                suppressContentEditableWarning
                ref={text3Ref}
                value={promptStepOneDataOriginal?.promptText3}
                onInput={(e) => {
                  const textValue = e.currentTarget.innerText;
                  handlePromptStepOneandTwoData(textValue, "promptText3");
                  text3Ref.current.classList.remove("border-red");
                  if (textValue.length > 1000) {
                    // Truncate to 1000 characters
                    e.currentTarget.innerText = textValue.slice(0, 1000);

                    // Move cursor to the end
                    const range = document.createRange();
                    const sel = window.getSelection();
                    range.selectNodeContents(e.currentTarget);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                  }
                  e.preventDefault();
                }}
                onBlur={(e) => handlePIIChange(e)}
                className={
                  isReadonlyAccess
                    ? "prompt-textarea prompt-pii disabled-element"
                    : "prompt-textarea prompt-pii"
                }
                rows="5"
              ></div>
            </div>
          </div>
          <div
            className={
              isReadonlyAccess
                ? "preference-wrapper disabled-parent"
                : "preference-wrapper"
            }
          >
            <label>
              Preference{" "}
              {!promptStepOneDataOriginal?.isImported && (
                <span className="red">*</span>
              )}
            </label>

            <div
              className={
                isReadonlyAccess ? "pref-block disabled-element" : "pref-block"
              }
            >
              <div ref={divPreferencesRef}>
                <SelectByPreferences
                  onPreferencesSelection={onPreferencesSelection}
                  creativityData={creativityData}
                  selectPreferences={
                    promptStepOneDataOriginal?.selectPreferences
                  }
                  isReadonlyAccess={isReadonlyAccess}
                />
              </div>
              <input
                disabled={isReadonlyAccess}
                className={
                  isReadonlyAccess
                    ? "word-count-field numeric-input-box disabled-element"
                    : "word-count-field numeric-input-box"
                }
                ref={wordCountRef}
                onPaste={(e) => e.preventDefault()}
                value={promptStepOneDataOriginal?.inputWordCount}
                onChange={(e) => handleWordCountChange(e)}
                placeholder="Word Count"
              />
            </div>
          </div>
          {isReadonlyAccess === false && (
            <div
              className={
                isReadonlyAccess
                  ? "prompt-button-wrapper flex-end disabled-parent"
                  : "prompt-button-wrapper flex-end"
              }
            >
              <button
                disabled={isReadonlyAccess}
                onClick={() => handleRegenerateClick()}
                className={
                  isReadonlyAccess
                    ? "genrate-btn disabled-element"
                    : "genrate-btn "
                }
              >
                Regenerate All
              </button>
            </div>
          )}
        </div>

        {showCropImagePopup && (
          <CropImage
            handleSaveImage={handleImageSave}
            handleCancelClick={() => handleImageCancelClick()}
          ></CropImage>
        )}
      </div>
      <div className="dash-section p20 prompt-step-two">
        <div className="prompt-review">
          <div className="prompt-step-name">
            {promptMessage?.length} Prompt(s){" "}
            {promptData?.isImported ? "Imported" : "Generated"}
          </div>
          <div className="prompt-step-desc">
            Compare the generated based on your prompt
          </div>
          <div className="prompt-gen">
            {!promptData?.isImported && (
              <div className="selected-tag">
                {mksDefaultConfiguration?.ChatGPTVersion}
              </div>
            )}
          </div>
        </div>
        <div className="prompt-review-wrap">
          {promptMessage?.length > 0 &&
            promptMessage.map((item) => (
              <div key={item.Id} className="prompt-review-box">
                <input
                  disabled={isReadonlyAccess}
                  type="radio"
                  name="prompt"
                  onChange={(e) => handlePromptSelected(e, item)}
                  className={
                    isReadonlyAccess
                      ? "p-checkbox disabled-element"
                      : "p-checkbox "
                  }
                  checked={
                    prevSelectedPrompts[0].PromptText === item.PromptText
                  }
                />
                <textarea
                  disabled={isReadonlyAccess}
                  readOnly
                  className={
                    isReadonlyAccess
                      ? "prompt-textarea disabled-element"
                      : "prompt-textarea"
                  }
                  rows="5"
                  value={item.PromptText}
                ></textarea>
              </div>
            ))}
        </div>
        <div
          className={
            isReadonlyAccess
              ? "dropdown-with-button disabled-parent"
              : "dropdown-with-button"
          }
        >
          <div
            className={
              isReadonlyAccess
                ? "prompt-title-wrap disabled-parent"
                : "prompt-title-wrap"
            }
          >
            <select
              data-title="selected skill"
              disabled={isReadonlyAccess}
              value={promptStepOneDataOriginal?.selectedSkill}
              className={
                isReadonlyAccess
                  ? "prompt-skill disabled-element"
                  : "prompt-skill prompt-hoverskill"
              }
              onChange={(e) => {
                handleSelectedSkillChange(e.target.value);
                if (e.target.value !== "-1")
                  skillref.current.classList.remove("border-red");
                e.preventDefault();
              }}
              ref={skillref}
            >
              <option value="-1">Select Skill</option>
              {useSkills?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.Name}
                </option>
              ))}
            </select>
          </div>
          {/* {isLoadingTest && (
            <button className="genrate-btn">
              <div className="btn-spinner">
                <span className="loadspinner"></span> Loading...
              </div>
            </button>
          )} */}

          {promptMessage?.length > 0 && (
            <button
              onClick={() => handleTestGeneratedPrompt()}
              className="genrate-btn"
            >
              Test Prompt
            </button>
          )}
        </div>
      </div>
      <PromptResults
        showTab={showTab}
        setShowTab={setShowTab}
        chatbotResponse={chatbotResponse}
        promptStepOneDataOriginal={promptStepOneDataOriginal}
      ></PromptResults>
    </>
  );
};

export default React.memo(UpdatePromptStepOneandTwo);
